import React from 'react';
import { useMedia } from './context/MediaContext';

const InGameMiniOverlay = () => {
  const { 
    songs, 
    playAudio, 
    stopAudio, 
    isPlaying, 
    currentSongIndex 
  } = useMedia();

  // Wenn keine Musik spielt, zeige nichts an
  if (!isPlaying || currentSongIndex === null || !songs[currentSongIndex]) {
    return null;
  }

  const currentSong = songs[currentSongIndex];

  return (
    <div className="fixed bottom-16 right-4 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-3 shadow-lg flex items-center gap-3 max-w-xs">
        <button
          onClick={() => stopAudio()}
          className="w-10 h-10 flex items-center justify-center text-white rounded-full bg-blue-500 hover:bg-blue-600 transition-colors"
          data-testid="mini-player-pause-button"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <rect x="6" y="4" width="4" height="16" />
            <rect x="14" y="4" width="4" height="16" />
          </svg>
        </button>
        <div className="flex-1 overflow-hidden">
          <div className="text-sm font-bold text-black truncate">{currentSong.name}</div>
          <div className="text-xs text-gray-500">Now Playing</div>
        </div>
      </div>
    </div>
  );
};

export default InGameMiniOverlay;
